// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__l96TB","dragIcon":"SortableItem_dragIcon__2hbbt","disabled":"SortableItem_disabled__2EoKY"};